import { useContext } from 'react';

import FeatureFlagsContext from '.';

export default function useFeatureFlags() {
  const features = useContext(FeatureFlagsContext);

  return function (key: string) {
    return key in features && features[key];
  };
}
